<div class="titleblock">
  <h3 class="title1level">
    Gestione ruoli dipartimento
  </h3>
  <p>
    <a (click)="addRole()" href="javascript:void(0)">
      Aggiungi Ruolo
      <span class="glyphicon glyphicon-plus-sign"></span>
    </a>
  </p>
</div>
<div class="titleblock">
  <h3 class="title1level" style="padding: 25px 0px 0px 0px"></h3>
  <p style="margin-top: -20px">
    <a (click)="refresh()" href="javascript:void(0)">
      Aggiorna
      <span class="glyphicon glyphicon-refresh"></span>
    </a>
  </p>
</div>


<div *ngIf="roles && roles.totalItems > 0" class="container_dati_generali">
  <app-ruoli-list [pagable] = "pagable" (delete)="onDelete($event)" (edit)="onEdit($event)"
    [roles]="roles" [hasAutoRefresh]="true" (refreshEvent)="refresh($event)" [resetCurrentPage]="resetCurrentPage"></app-ruoli-list>
</div>

<div *ngIf="!roles || roles.totalItems === 0" class="container_dati_generali">
  <h5>Non ci sono ruoli</h5>
</div>
